import React, { useState } from 'react';
import { Button, Modal } from 'antd';
import { useNavigate } from 'react-router-dom';

interface LogoutProps {
    openPopup?: boolean;
}
const LogoutPopUp: React.FC<LogoutProps> = ({openPopup = false}) => {
  const [modal2Open, setModal2Open] = useState(openPopup);
  const navigate = useNavigate(); // React Router hook for navigation


  return (
    <>
      <Modal
        title="Please sign in again"
        centered
        open={modal2Open}
        onOk={() => {   
                localStorage.removeItem('login_token');
                navigate("/login");     
        }}
      >
        <p>You were signed out of your account.</p>
      </Modal>
    </>
  );
};

export default LogoutPopUp;